import $ from "jquery";
import ElementFilter from "./util/element_filter";
import ElementFilterForm from "./util/element_filter_form";

$(document).on("turbolinks:load", function () {
  const filter = new ElementFilter($("#favourite-cards"),
    ".card-container",
    [".card-favourites-search-title"]
  );

  const filterInput = $("#card_filter_filter");
  const form = filterInput.closest("form");
  new ElementFilterForm(form, filterInput, filter);
});
